'use client';

import React, { useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const allArticles = [
{
  id: 1,
  category: 'Partnerships',
  date: 'Dec 13, 2024',
  author: null,
  title: 'NeXSYS Group Machine Partnerships',
  excerpt: 'NeXSYS Group has finalized automation partnerships for factory deployment, with agreements in place covering the development of automated cutting, bending, and welding systems for the production of NeXSYS node and column components.',
  img: '/assets/images/news-featured-1-BpqHa9xn-1774077260924.png',
  featured: true
},
{
  id: 2,
  category: 'Product Launches',
  date: 'Oct 28, 2025',
  author: null,
  title: 'NeXSYS Group is launching the next-generation construction framing system',
  excerpt: 'Introducing a new paradigm for the built environment through systemized delivery and a significant reduction in risk.',
  img: '/assets/images/news-featured-2-BUHbBd3W-1774077314325.png',
  featured: true
},
{
  id: 3,
  category: 'Industry Insights',
  date: 'Dec 4, 2024',
  author: 'Research Team',
  title: 'Development of library of building assemblies.',
  excerpt: 'NeXSYS working with renowned architectural companies in developing building system cater to various climatic demands.',
  img: '/assets/images/6a7f5100-acb2-43e7-9bd7-fa207afc01ae-1774077428979.png',
  featured: false
},
{
  id: 4,
  category: 'Events',
  date: 'Jan 19, 2026',
  author: 'Marketing Team',
  title: 'Coming Events',
  excerpt: 'Show casing our system and platform in comming industry events, join us and share coffee and see how our platform can assist you. From our structural system to planning platform.',
  img: '/assets/images/modular-flow-platform-DQFmzGIO-1774077482156.png',
  featured: false
}];


const categories = ['All', 'Announcements', 'Product Launches', 'Partnerships', 'Industry Insights', 'Events'];

export default function NewsPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubscribe = async () => {
    if (!email) {
      setSubscribeStatus('error');
      return;
    }
    setSubscribeStatus('loading');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fullName: 'Newsletter Subscriber',
          email: email,
          message: `New newsletter subscription from the News page. Subscriber email: ${email}`,
        }),
      });
      if (res?.ok) {
        setSubscribeStatus('success');
        setEmail('');
      } else {
        setSubscribeStatus('error');
      }
    } catch {
      setSubscribeStatus('error');
    }
  };

  const featuredArticles = allArticles?.filter((a) => a?.featured);
  const recentArticles = allArticles?.filter((a) => !a?.featured);

  const filteredFeatured = activeCategory === 'All' ?
  featuredArticles :
  featuredArticles?.filter((a) => a?.category === activeCategory);

  const filteredRecent = activeCategory === 'All' ?
  recentArticles :
  recentArticles?.filter((a) => a?.category === activeCategory);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative min-h-[40vh] flex items-end pb-16 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="/assets/images/1766997728-1774455557836.png"
              alt="Construction news"
              className="w-full h-full object-cover object-top" />
            
            <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, hsla(215, 28%, 10%, 0.7) 0%, hsla(207, 52%, 25%, 0.8) 100%)' }} />
          </div>
          <div className="relative container mx-auto container-padding pt-20">
            <div className="max-w-3xl">
              <h1 className="text-hero lg:text-hero-lg font-heading font-bold text-white mb-6">
                News &amp; Updates
              </h1>
              <p className="text-xl text-white/80 leading-relaxed">
                Stay informed with the latest announcements, product launches, partnerships, and insights from the NeXSYS team.
              </p>
            </div>
          </div>
        </section>

        {/* Filter Tabs */}
        <section className="py-8 bg-card border-b border-border">
          <div className="container mx-auto container-padding">
            <div className="flex flex-wrap gap-2">
              {categories?.map((cat) =>
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                activeCategory === cat ?
                'bg-primary text-white shadow-md' :
                'bg-nexsys-surface text-muted-foreground hover:bg-nexsys-light-gray'}`
                }>
                
                  {cat}
                </button>
              )}
            </div>
          </div>
        </section>

        {/* Featured Stories */}
        {filteredFeatured?.length > 0 &&
        <section className="section-padding bg-card">
            <div className="container mx-auto container-padding">
              <h2 className="text-section font-heading font-bold text-foreground mb-8">
                Featured Stories
              </h2>
              <div className="grid lg:grid-cols-2 gap-8">
                {filteredFeatured?.map((article) =>
              <article key={article?.id} className="bg-white rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1 border border-border">
                    <div className="aspect-video overflow-hidden">
                      <img src={article?.img} alt={article?.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-4 mb-4">
                        <span className="text-xs font-semibold bg-primary/10 text-primary px-3 py-1 rounded-full">
                          {article?.category}
                        </span>
                        <span className="text-xs text-muted-foreground flex items-center gap-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                            <line x1="16" x2="16" y1="2" y2="6" />
                            <line x1="8" x2="8" y1="2" y2="6" />
                            <line x1="3" x2="21" y1="10" y2="10" />
                          </svg>
                          {article?.date}
                        </span>
                      </div>
                      <h2 className="font-heading font-bold text-xl text-foreground mb-3">{article?.title}</h2>
                      <p className="text-muted-foreground text-sm leading-relaxed">{article?.excerpt}</p>
                    </div>
                  </article>
              )}
              </div>
            </div>
          </section>
        }

        {/* Recent News */}
        {filteredRecent?.length > 0 &&
        <section className="section-padding">
            <div className="container mx-auto container-padding">
              <h2 className="text-section font-heading font-bold text-foreground mb-8">
                Recent News
              </h2>
              <div className="flex flex-col gap-5">
                {filteredRecent?.map((article) =>
              <article key={article?.id} className="bg-white rounded-xl border border-border shadow-card hover:shadow-card-hover transition-all duration-300 cursor-pointer overflow-hidden">
                    <div className="flex flex-row items-stretch">
                      {/* Image on the left */}
                      <div className="flex-shrink-0 w-40 sm:w-48 md:w-56 overflow-hidden">
                        <img src={article?.img} alt={article?.title} className="w-full h-full object-cover" />
                      </div>
                      {/* Vertical divider line */}
                      <div className="w-px bg-border flex-shrink-0" />
                      {/* Content on the right */}
                      <div className="flex-1 p-5 flex flex-col justify-center">
                        <div className="flex items-center gap-3 mb-3 flex-wrap">
                          <span className="text-xs font-semibold border border-primary text-primary px-3 py-1 rounded-full bg-transparent">
                            {article?.category}
                          </span>
                          <span className="text-xs text-muted-foreground flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                              <line x1="16" x2="16" y1="2" y2="6" />
                              <line x1="8" x2="8" y1="2" y2="6" />
                              <line x1="3" x2="21" y1="10" y2="10" />
                            </svg>
                            {article?.date}
                          </span>
                          {article?.author &&
                      <span className="text-xs text-muted-foreground flex items-center gap-1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                <circle cx="12" cy="7" r="4" />
                              </svg>
                              {article?.author}
                            </span>
                      }
                        </div>
                        <h3 className="font-heading font-bold text-lg text-foreground mb-2">{article?.title}</h3>
                        <p className="text-muted-foreground text-sm leading-relaxed">{article?.excerpt}</p>
                      </div>
                    </div>
                  </article>
              )}
              </div>
              <div className="mt-10 text-center">
                <button className="px-8 py-3 border-2 border-primary text-primary font-semibold rounded-lg hover:bg-primary/5 transition-all duration-200">
                  Load More Articles
                </button>
              </div>
            </div>
          </section>
        }

        {/* Newsletter Section */}
        <section className="section-padding bg-gradient-dark">
          <div className="container mx-auto container-padding text-center">
            <h2 className="text-section font-heading font-bold text-white mb-4">
              Stay Updated
            </h2>
            <p className="text-white/70 text-lg mb-8 max-w-2xl mx-auto">
              Subscribe to our newsletter for the latest news, product updates, and industry insights.
            </p>
            {subscribeStatus === 'success' ? (
              <div className="max-w-md mx-auto">
                <p className="text-white text-lg font-semibold">✓ You&apos;re subscribed! Thank you for joining.</p>
              </div>
            ) : (
              <>
                <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e?.target?.value)}
                    className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-primary" />
                  <button
                    onClick={handleSubscribe}
                    disabled={subscribeStatus === 'loading'}
                    className="bg-banana text-banana-foreground font-semibold px-6 py-3 rounded-lg hover:bg-banana/90 transition-all duration-200 whitespace-nowrap disabled:opacity-60">
                    {subscribeStatus === 'loading' ? 'Subscribing...' : 'Subscribe'}
                  </button>
                </div>
                {subscribeStatus === 'error' && (
                  <p className="text-red-400 text-sm mt-2">Please enter a valid email address.</p>
                )}
              </>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>);

}